import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled from 'styled-components';
import { makeContainerMaxWidth, makeContainer, makeMainContainer, makeRow, makeCol } from './mixins';
/**
 * Container widths
 * Set the container width, and override it for fixed navbars in media queries.
 */

export var MainContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  return makeMainContainer(props);
}, makeContainerMaxWidth);
/**
 * Container widths
 * Set the container width, and override it for fixed navbars in media queries.
 */

export var Container = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  return makeContainer(props);
}, makeContainerMaxWidth);
/**
 * Fluid container
 * Utilizes the mixin meant for fixed width containers, but with 100% width for
 * fluid, full width layouts.
 */

export var ContainerFluid = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeContainer(props);
});
/**
 * Row
 * Rows contain and clear the floats of your columns.
 */

export var Row = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeRow(props);
});
export var Col = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeCol(props);
});